import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button } from '@mui/material';
import { motion } from 'framer-motion';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactFormWidget.css';

const ContactFormWidget = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    budget: '',
    topic: '',
    synopsis: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <Box className="contact-widget-section">
      <Container maxWidth="lg">
        <Box className="contact-widget-wrapper">
          {/* Left Side - Text Content */}
          <Box className="contact-widget-content">
            <Typography variant="subtitle1" className="contact-widget-subtitle">
              Let's Connect
            </Typography>
            <Typography variant="h2" className="contact-widget-title">
              Thanks for reaching us!
            </Typography>
            <Typography variant="body1" className="contact-widget-description">
              We transform your innovative ideas into powerful solutions, adding substantial value to your business concepts. Our commitment to excellence and client satisfaction drives us to build lasting partnerships. Let's collaborate to bring your vision to life.
            </Typography>
          </Box>

          {/* Right Side - Contact Form */}
          <Box className="contact-widget-form">
            <form onSubmit={handleSubmit}>
              <div className="form-fields-grid">
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Hi, I am</Typography>
                  <TextField
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="What people call you"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Reach me via Email</Typography>
                  <TextField
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    placeholder="Email"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Select your Budget range</Typography>
                  <TextField
                    name="budget"
                    select
                    value={formData.budget}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Select a range"
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="">Select a range</option>
                    <option value="0-5k">$0 - $5,000</option>
                    <option value="5k-10k">$5,000 - $10,000</option>
                    <option value="10k-25k">$10,000 - $25,000</option>
                    <option value="25k+">$25,000+</option>
                  </TextField>
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">I want to talk about</Typography>
                  <TextField
                    name="topic"
                    select
                    value={formData.topic}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Select an Option"
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="">Select an Option</option>
                    <option value="web">Web Development</option>
                    <option value="mobile">Mobile Development</option>
                    <option value="cloud">Cloud Solutions</option>
                    <option value="ai">AI & Machine Learning</option>
                    <option value="design">UI/UX Design</option>
                    <option value="other">Other</option>
                  </TextField>
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Or you can call me at</Typography>
                  <TextField
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Phone number"
                    type="tel"
                  />
                </Box>
                <Box className="form-field">
                  <Typography variant="body2" className="field-label">Attachment</Typography>
                  <Box className="upload-box">
                    Choose a file
                  </Box>
                </Box>
                <Box className="form-field full-width">
                  <Typography variant="body2" className="field-label">Project Synopsis</Typography>
                  <TextField
                    name="synopsis"
                    value={formData.synopsis}
                    onChange={handleChange}
                    required
                    multiline
                    rows={3}
                    variant="outlined"
                    placeholder="Enter Your Synopsis"
                  />
                </Box>
                {/* <Box className="form-field full-width">
                  <ReCAPTCHA
                    sitekey="YOUR_RECAPTCHA_SITE_KEY"
                    onChange={() => {}}
                  />
                </Box> */}
              </div>
              <Box className="privacy-notice">
                By submitting this form, I consent that Virves can process my data for the purpose of making me an offer for their services. Read our <a href="/privacy-policy" className="privacy-link">Privacy Policy</a>.
              </Box>
              <Button
                type="submit"
                variant="contained"
                className="submit-button"
              >
                Submit
              </Button>
            </form>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactFormWidget; 